
/*
  This information is based on the shared memory Analog In
 */
export class MeasurementData {
  number: number = 0;
  refreshrate: number = 0;
  tmsc_input: number = 0;
  tmsc_parameter: number = 0;
  rawvalue: number = 0;
  timestamp: number= 0;
  measurementaccess: number= 0;
  status: number= 0;
  department: number= 0;
  channelfull: number= 0;
  measurementvalue: number= 0;
  owner: number= 0;
  description: string = "descr";
  measurementunit: string = "unit";
  department_name: string = "depname";
  measurementprecision: number = 0;
}

export interface MeasurementDataList {
  MeasurementData: MeasurementData[];
}



